import { has } from "lodash";
import { API_ENDPOINTS } from "./constants";

export const EventBus = {
  events: {},
  dispatch(event, data) {
    if (!this.events[event]) return;

    this.events[event].forEach((callback) => callback(data));
  },
  subscribe(event, callback) {
    if (!this.events[event]) this.events[event] = [];

    this.events[event].push(callback);
  },
};

export const subscribeEventBus = async (
  endpoint,
  setFunction,
  additionalSetFunction = null
) => {
  try {
    EventBus.subscribe(`dataReceived-${endpoint}`, (data) => {
      if (has(data, "data")) {
        setFunction(data.data || []);
      } else {
        if (endpoint === API_ENDPOINTS.FRIEND_REQUESTS) {
          setFunction(data.incoming_requests || []);
          additionalSetFunction(data.outgoing_requests);
        } else {
          setFunction(data || []);
        }
      }
    });
  } catch (error) {
    console.error("Error subscribing to EventBus:", error);
  }
};
